import { render, staticRenderFns } from "./DisplayVideo.vue?vue&type=template&id=53610645&"
import script from "./DisplayVideo.vue?vue&type=script&lang=js&"
export * from "./DisplayVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports